var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 3.75008C15.0002 3.51996 14.8136 3.33341 14.5835 3.33341H5.41683C5.18671 3.33341 5.00016 3.51996 5.00016 3.75008V15.0233C5.00016 15.3051 5.29673 15.4884 5.5488 15.3624C6.25261 15.0105 7.08104 15.0105 7.78486 15.3624L9.62748 16.2837C9.86209 16.401 10.1382 16.401 10.3728 16.2837L12.2155 15.3624C12.9193 15.0105 13.7477 15.0105 14.4515 15.3624C14.7036 15.4884 15.0002 15.3051 15.0002 15.0233V3.75008ZM16.6668 17.6592C16.6668 17.969 16.3409 18.1704 16.0638 18.0319L13.7062 16.8531C13.4716 16.7358 13.1954 16.7358 12.9608 16.8531L11.1182 17.7744C10.4144 18.1263 9.58595 18.1263 8.88213 17.7744L7.03951 16.8531C6.8049 16.7358 6.52876 16.7358 6.29415 16.8531L3.9365 18.0319C3.65946 18.1704 3.3335 17.969 3.3335 17.6592V1.66675H16.6668V17.6592Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 5C7.0396 5 6.6665 5.3731 6.6665 5.83333C6.6665 6.29357 7.0396 6.66667 7.49984 6.66667H9.1665C9.62674 6.66667 9.99984 6.29357 9.99984 5.83333C9.99984 5.3731 9.62674 5 9.1665 5H7.49984Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 5C12.0396 5 11.6665 5.3731 11.6665 5.83333C11.6665 6.29357 12.0396 6.66667 12.4998 6.66667C12.9601 6.66667 13.3332 6.29357 13.3332 5.83333C13.3332 5.3731 12.9601 5 12.4998 5Z",
    fill: "#777E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 9.16667C6.6665 8.70643 7.0396 8.33333 7.49984 8.33333H9.1665C9.62674 8.33333 9.99984 8.70643 9.99984 9.16667C9.99984 9.6269 9.62674 10 9.1665 10H7.49984C7.0396 10 6.6665 9.6269 6.6665 9.16667Z",
    fill: "#777E91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 8.33333C12.0396 8.33333 11.6665 8.70643 11.6665 9.16667C11.6665 9.6269 12.0396 10 12.4998 10C12.9601 10 13.3332 9.6269 13.3332 9.16667C13.3332 8.70643 12.9601 8.33333 12.4998 8.33333Z",
    fill: "#777E91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 12.5C6.6665 12.0398 7.0396 11.6667 7.49984 11.6667H9.1665C9.62674 11.6667 9.99984 12.0398 9.99984 12.5C9.99984 12.9602 9.62674 13.3333 9.1665 13.3333H7.49984C7.0396 13.3333 6.6665 12.9602 6.6665 12.5Z",
    fill: "#777E91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 11.6667C12.0396 11.6667 11.6665 12.0398 11.6665 12.5C11.6665 12.9602 12.0396 13.3333 12.4998 13.3333C12.9601 13.3333 13.3332 12.9602 13.3332 12.5C13.3332 12.0398 12.9601 11.6667 12.4998 11.6667Z",
    fill: "#777E91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 2.50008C1.6665 2.03984 2.0396 1.66675 2.49984 1.66675H17.4998C17.9601 1.66675 18.3332 2.03984 18.3332 2.50008C18.3332 2.96032 17.9601 3.33341 17.4998 3.33341H2.49984C2.0396 3.33341 1.6665 2.96032 1.6665 2.50008Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/Receipt.6a000424cb4cdfaade6f0f739bb9872b.svg";
export { ForwardRef as ReactComponent };